module.exports = __webpack_public_path__ + "static/media/unkindHide2.1a82d55f.png";